import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import JSONRenderer from '@components/JSONRenderer'

import { SourceType } from './types'

type AISearchSourcesProps = {
  sources: SourceType[]
  onSourceClick: (source: SourceType) => void
}

const SourcesList = styled.div`
  ${({
    theme: {
      spacing: { spacing8, spacing16 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing8};
    padding: 0 ${spacing16};
    overflow-y: auto;
  `}
`

const Divider = styled.div`
  ${({
    theme: {
      colors: { strokeWeak },
      spacing: { spacing16 },
    },
  }) => css`
    border-bottom: 1px solid ${strokeWeak};
    margin-top: ${spacing16};
    margin-bottom: ${spacing16};
  `}
`

const AISearchSources: FunctionComponent<AISearchSourcesProps> = ({
  sources,
  onSourceClick,
}) => {
  return (
    <SourcesList>
      <div>
        {sources.map((source) => (
          <div key={source?.articleId} onClick={() => onSourceClick(source)}>
            <JSONRenderer>
              {{
                ...source,
                kind: ['teaser-standard-horizontal'],
                link: {
                  ...source.link,
                  target: '_blank',
                },
                track: false,
              }}
            </JSONRenderer>
            <Divider />
          </div>
        ))}
      </div>
    </SourcesList>
  )
}

export default AISearchSources
